import {
  CREATE_SALE_ORDER_SUCCESS,
  FETCH_ASSETS_BY_LOCATION_SUCCESS,
  FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS,
  FETCH_SALE_ORDER_SUCCESS,
  GET_SALE_ORDER_SUCCESS,
  SAVE_SALE_ORDER_QUERY,
  UNMOUNT_SALE_ORDER_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetsList: [],
  equipmentData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SALE_ORDER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_SALE_ORDER_SUCCESS: {
      const query = {
        ...state.query,
        pagination: {
          ...state.query.pagination,
          total: action.count
        }
      };

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.count,
      }
    }

    case CREATE_SALE_ORDER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_SALE_ORDER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_ASSETS_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        assetsList: action.data,
      }
    }

    case FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS: {
      return {
        ...state,
        equipmentData: action.data,
      }
    }

    case UNMOUNT_SALE_ORDER_SUCCESS: {
      return {
        ...state,
        equipmentData: {},
        edit: {},
      }
    }


    default:
      return state;
  }
}
